import * as z from 'zod';

import { schema } from '.';

export const consignadoSchema = z.object({
  payment: z.optional(
    z.object({
      Type: z.optional(z.number()),
    }),
  ),
  user: schema,
});

export type ConsignadoSchema = z.infer<typeof consignadoSchema>;
